const stripReactIdOfColon = (str) => str.replaceAll(':', '');

export { stripReactIdOfColon };
